import React from 'react';

function Loader() {
  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-white/70 backdrop-blur-sm"
      style={{ zIndex: 10000 }}
    >
      <div className="flex flex-col items-center gap-4">
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-slate-200 border-t-blue-600" />
        <span className="text-sm font-medium text-slate-500">Loading…</span>
      </div>
    </div>
  );
}

export default Loader;
